// eslint no-use-before-define: 0
import { Tuple, configureStore } from "@reduxjs/toolkit"
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"
import logger from "redux-logger"
import { Persistor, persistReducer, persistStore } from "redux-persist"
import storage from "redux-persist/lib/storage"
import { thunk } from "redux-thunk"
import monitorReducerEnhancer from "./enhancers/monitor-reducer"
import rootReducer from "./reducers"
// Middleware for logs in dev enviroment only
// const middlewares = [thunk];

export type RootState = ReturnType<typeof rootReducer /*& PersistPartial*/>
// redux persist configuration
const persistConfig = {
	key: "root",
	storage,
	whitelist: ["auth"], // the reducer objects to persist
}

const persistStateReducer = persistReducer(persistConfig, rootReducer)

// Custom logger middleware that only logs in development and ignores `persist/PERSIST` in production
const customLogger = (store) => (next) => (action) => {
	if (
		process.env.NODE_ENV === "production" &&
		action.type === "persist/PERSIST"
	) {
		return next(action) // Skip logging this action in production
	}
	return logger(store)(next)(action) // Otherwise, use the default logger
}

// create redux store
export const store = configureStore({
	reducer: persistStateReducer,
	devTools: { trace: false, traceLimit: 25 },
	middleware: () => new Tuple(thunk, monitorReducerEnhancer, customLogger),
	/* [
            axiosMiddleware,
            logger,
            monitorReducerEnhancer,
            ...getDefaultMiddleware({
                serializableCheck: {
                    // Ignore actions from redux-persist
                    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
                },
                immutableCheck: false
            })
        ].filter(Boolean)*/
})

export const persistor: Persistor = persistStore(store)

export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useTypedSelector: TypedUseSelectorHook<RootState> =
	useSelector as TypedUseSelectorHook<RootState>
